import {
  Card,
  CardContent,
  Divider,
  FormControl,
  Grid,
  MenuItem,
  TextField
} from '@material-ui/core';

import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
import AttachmentIcon from '@material-ui/icons/Attachment';
import MonochromePhotosIcon from '@material-ui/icons/MonochromePhotos';
import AlertYasal from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import 'react-html5-camera-photo/build/css/index.css';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import Alert from 'src/components/Alert';
import FilesPreview from 'src/components/FilePreview';
import axios from 'src/utils/axios';
import { loadFotograf } from 'src/utils/storage/StrPhoto';
import CamPopup from '../../components/CamPopup';
import CCFilePopup from '../../components/CCFilePopup';
import FilePopup from '../../components/FilePopup';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper
  },
  gridList: {
    width: 500,
    height: 450
  },
  icon: {
    color: 'rgba(255, 255, 255, 0.54)'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  divider: {
    backgroundColor: '#1D3343'
  },
  formControl: {
    marginTop: theme.spacing(2),
    width: '100%'
  }
}));

function Detay({ className, ReceiptNo, readonly, tasks, ...rest }) {
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const [Loading, setLoading] = useState(true);
  const [openCam, setOpenCam] = useState(false);
  const [openFile, setOpenFile] = useState(false);
  const [DosyaTipi, setDosyaTipi] = useState(1);
  const [DosyaIsmi, setDosyaIsmi] = useState('');
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: t('success_message')
  });
  const [uyari, setUyari] = React.useState(false);
  const [uyariTip, setUyariTip] = React.useState();
  const [files, setFiles] = useState([]);
  const [CCFilePopupOpen, setCCFilePopupOpen] = React.useState(false);
  const [fileType,setFileType] = useState([]);
  const storeData = tasks.tasks.find(
    d => parseInt(d.ReceiptNo) === parseInt(ReceiptNo)
  );
  const locale = localStorage.getItem('i18nextLng');

  const DosyaTipihandleChange = event => {
    // setDosyaIsmi(event.target.name);

    setDosyaTipi(event.target.value);
  };
  const handleFileText = event => {
    setDosyaIsmi(event.target.innerText);
  };

  const handleChangeDosyaIsmi = event => {
    const { value } = event.target;
    setDosyaIsmi(value);
  };
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  const handleCamOpen = () => {
    if (DosyaTipi === undefined) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('Dosya_sec_error')
      });
      setUyariTip('error');
      setUyari(true);
      return;
    }
    setOpenCam(true);
  };
  const handleCamClose = type => {
    if (type === 'file') {
      setOpenFile(false);
    } else {
      setOpenCam(false);
    }
    setLoading(true);
    const localPhotos = loadFotograf(ReceiptNo);
    setFiles(localPhotos);
    axios
      .get(`/GetSiriusFileList/${ReceiptNo}`)
      .then(response => {
        if (response.data === '') {
          setLoading(false);
          setFiles(localPhotos);
        } else {
          const Deger = response.data;
          setFiles([...Deger, ...localPhotos]);
          setLoading(false);
        }
      })
      .catch(error => {
        setFiles(localPhotos);
        setLoading(false);
      });
  };
  const handleFileOpen = () => {
    if (DosyaTipi === undefined) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('Dosya_sec_error')
      });
      setUyariTip('error');
      setUyari(true);
      return;
    }
    setOpenFile(true);
  };
  const handleFileClose = dataUri => {
    handleCamClose('file');
  };
  const handleCCFileClose = () => {
    setCCFilePopupOpen(false);
  };

  const fetchPhotos = mounted => {
    setLoading(true);
    const localPhotos = loadFotograf(ReceiptNo);
    setFiles(localPhotos);
    axios
      .get(`/GetSiriusFileList/${ReceiptNo}`)
      .then(response => {
        if (mounted) {
          if (response.data === '') {
            setFiles(localPhotos);
            setLoading(false);
          } else {
            const Deger = response.data;
            setFiles([...Deger, ...localPhotos]);
            setLoading(false);
          }
        }
      })
      .catch(error => {
        setFiles(localPhotos);
        setLoading(false);
      });
  };
  useEffect(() => {
    let mounted = true;
    // setLoading(true);
    fetchPhotos(mounted);
    return () => {
      mounted = false;
    };
    // eslint-disable-next-line
  }, [ReceiptNo]);

  const getFileType = () => {
    setLoading(true);
    axios
      .get(`/GetFileType`)
      .then(response => {
        if(response.data.length > 0 && response.data != ""){
            setFileType(response.data);
        }else{
            setFileType([]); //no data
        }
        setLoading(false);
      })
      .catch(error => {
        setUyariTip('error');
        setUyari(true);
        setLoading(false);
      });
  };

  useEffect(()=>{
    getFileType();
  }, [locale])

    // WorkOrder verisi yüklenene kadar bekle
  if (!storeData || !storeData.WorkOrderGuid) {
    return (
      <Card>
        <CardContent>
          <CircularProgress status="loading" style={{ marginLeft: '50%' }} />
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardContent>
        {uyari ? (
          <Alert
            onClose={uyariKapat}
            open={uyari}
            message={responseMessage.ErrorDescription}
            variant={uyariTip}
          />
        ) : (
          <div />
        )}
        <Grid container spacing={1} justify="space-between">
          <Grid item xs={4} align="left">
            <IconButton aria-label="settings" onClick={handleCamOpen}>
              <AddAPhotoIcon color="primary" />
            </IconButton>
          </Grid>
          <Grid item xs={4} align="center">
            <IconButton
              aria-label="settings"
              // onClick={setCCFilePopupOpen(true)}
              onClick={() => setCCFilePopupOpen(true)}
            >
              <MonochromePhotosIcon color="secondary" />
            </IconButton>
          </Grid>
          <Grid item xs={4} align="right">
            <IconButton aria-label="settings" onClick={handleFileOpen}>
              <AttachmentIcon color="primary" />
            </IconButton>
          </Grid>
        </Grid>
        <FormControl variant="outlined" className={classes.formControl}>
          <TextField
            size="small"
            fullWidth
            native
            select
            variant="outlined"
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            label={t('DosyaTipi')}
            value={DosyaTipi}
            onChange={event => {
              DosyaTipihandleChange(event);
            }}
          >
            {fileType.map(type => (
               <MenuItem key={0} value={type.Id} onClick={handleFileText}>
                  {type.FieldText}
              </MenuItem>
            ))}
          </TextField>
        </FormControl>
        <br />
        <br />
        <TextField
          label={t('Dosya_ismi')}
          size="small"
          fullWidth
          name="DosyaIsmi"
          autoComplete="no"
          value={DosyaIsmi}
          onChange={handleChangeDosyaIsmi}
          variant="outlined"
        />
        <br />
        <br />
        <AlertYasal severity="warning">{t('yasal_uyari')}</AlertYasal>
      </CardContent>
      <Divider className={classes.divider} />
      <CardContent className={classes.content}>
        {Loading ? (
          <CircularProgress status="loading" style={{ marginLeft: '50%' }} />
        ) : (
          <div />
        )}
        <FilesPreview
          ReceiptNo={ReceiptNo}
          WorkGuid={storeData.WorkOrderGuid}
          files={files}
          fetchPhotos={fetchPhotos}
          setLoading={setLoading}
        />
      </CardContent>

      <CamPopup
        onClose={handleCamClose}
        ReceiptNo={ReceiptNo}
        DosyaTipi={DosyaTipi}
        DosyaTipiText={DosyaIsmi}
        open={openCam}
      />
      <FilePopup
        onClose={handleFileClose}
        ReceiptNo={ReceiptNo}
        DosyaTipi={DosyaTipi}
        DosyaTipiText={DosyaIsmi}
        open={openFile}
      />
      <CCFilePopup
        onClose={handleCCFileClose}
        ReceiptNo={ReceiptNo}
        open={CCFilePopupOpen}
      />
    </Card>
  );
}

Detay.propTypes = {
  className: PropTypes.string
};

export default connect(state => ({ tasks: state.tasks1 }))(Detay);
